import { CSVLink } from 'react-csv';
import PropTypes from 'prop-types';
import { clearObject } from 'shared/utils';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import {
    DownloadCancel,
    DownloadContainer,
    DownloadPrepare
} from './styled';
import React, { useMemo } from 'react';

const DownloadList = ({
    downloadController = {},
    downloadFilters = {}
}) => {

    const { t } = useTranslation();
    const {
        data: downloadData = [],
        downloading = false,
        fileName = '',
        headers: downloadHeaders = [],
        manual = true,
        onDownload
    } = downloadController ?? {};

    const parsedData = useMemo(() => {
        const accessors = (downloadHeaders ?? []).reduce((acc, curr) => {
            if (!curr?.accessor) return acc;
            return {
                ...acc,
                [curr?.key]: curr?.accessor
            };
        }, {});
        return (downloadData ?? []).map(d => {
            const parsedElement = { ...d };
            Object.keys(accessors).forEach(key => {
                parsedElement[key] = accessors[key](parsedElement[key]);
            });
            return parsedElement;
        });
    }, [downloadData, downloadHeaders]);

    if (isEmpty(downloadController)) {
        return null;
    }
    
    return (
        <DownloadContainer>
            {
                isEmpty(downloadData) && manual
                    ? <>
                        {
                            !downloading
                                ? <DownloadPrepare onClick={ () => onDownload(clearObject(downloadFilters, true)) }>
                                    { t('Descargar datos detallados') }
                                </DownloadPrepare>
                                : <DownloadPrepare>
                                    { t('Generando reporte') }...
                                </DownloadPrepare>
                        }
                    </>
                    : <>
                        <CSVLink
                            className="download-button"
                            data={ parsedData ?? [] }
                            filename={ `${ fileName }${ downloadFilters?.start_date ? downloadFilters?.start_date : '' }${ downloadFilters?.end_date ? `-${ downloadFilters?.end_date }` : '' }.csv` }
                            headers={ downloadHeaders }
                            separator=";"
                            target="_blank"
                        >
                            { t('Descargar listado') }
                        </CSVLink>
                        {
                            manual &&
                            <>
                                { ' - ' }
                                <DownloadCancel onClick={ () => onDownload(clearObject(downloadFilters, true)) }>
                                    {
                                        !downloading
                                            ? t('Generar otro')
                                            : `${ t('Generando otro') }...`
                                    }
                                </DownloadCancel>
                            </>
                        }
                    </>
            }
        </DownloadContainer>
    );
};

DownloadList.propTypes = {
    downloadController: PropTypes.shape({
        data: PropTypes.array,
        downloading: PropTypes.bool,
        fileName: PropTypes.string,
        headers: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string
        })),
        manual: PropTypes.bool,
        onDownload: PropTypes.func
    }),
    downloadFilters: PropTypes.object
};

export default DownloadList;
